<template>
  <div id="app">
    <div v-if="showModalEditDevice">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Sửa thông tin thiết bị</h5>
                  <button
                    type="button"
                    @click="closeEditPhuLuc()"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 500px; overflow: scroll">
                  <ValidationObserver ref="contractAdd">
                    <form>
                      <div class="form-group row">
                        <label for="" class="col-sm-3 col-form-label">Mã phụ lục thiết bị:</label>
                        <div class="col-sm-9">
                          <input
                            :value="dataEdit.code"
                            disabled
                            type="text"
                            class="form-control"
                            id=""
                          />
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-sm-12">
                          <div class="table-responsive">
                            <table class="table table-hover table-bordered" id="tableScroll">
                              <thead class="thead-light">
                                <tr>
                                  <th scope="col" class="text-center">Tên thiết bị</th>
                                  <th scope="col" class="text-center" width="120">
                                    Số lượng thiết bị
                                  </th>
                                  <th scope="col" class="text-center" width="120">Serial</th>
                                  <th scope="col" class="text-center">Giá bán</th>
                                  <th scope="col" class="text-center">Thành tiền</th>
                                  <th scope="col" class="text-center"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  class="table-row"
                                  v-for="(item, index) in dataEditDevice"
                                  :key="index"
                                >
                                  <td class="text-center">
                                    <input class="form-control f12" :value="item.name" disabled />
                                  </td>
                                  <td align="right">
                                    <input
                                      min="1"
                                      type="number"
                                      class="form-control f12"
                                      disabled
                                      :value="item.quantity"
                                    />
                                  </td>
                                  <td align="right">
                                    <ValidationProvider
                                      v-if="item.name === 'PR_02'"
                                      rules="required|serialPR02"
                                      vid="serial"
                                      name="Mã serial"
                                    >
                                      <div class="my-3" slot-scope="{ errors }">
                                        <input
                                          min="1"
                                          type="text"
                                          class="form-control f12"
                                          :disabled="
                                            dataEdit.isCreatedWithContract &&
                                            dataEdit.state !== 'SIGNED_WAITING_APPROVED'
                                          "
                                          v-model="item.serialNumber"
                                        />
                                        <p class="text-danger pos-absolute">
                                          {{ errors[0] }}
                                        </p>
                                      </div>
                                    </ValidationProvider>
                                    <ValidationProvider
                                      v-else-if="item.name === 'SMART_POS'"
                                      rules="required|serialSmartPOS"
                                      vid="serial"
                                      name="Mã serial"
                                    >
                                      <div class="my-3" slot-scope="{ errors }">
                                        <input
                                          min="1"
                                          type="text"
                                          class="form-control f12"
                                          :disabled="
                                            dataEdit.isCreatedWithContract &&
                                            dataEdit.state !== 'SIGNED_WAITING_APPROVED'
                                          "
                                          v-model="item.serialNumber"
                                        />
                                        <p class="text-danger pos-absolute">
                                          {{ errors[0] }}
                                        </p>
                                      </div>
                                    </ValidationProvider>
                                  </td>
                                  <td align="right">
                                    <input
                                      class="form-control f12"
                                      disabled
                                      :value="item.price | fomatCurrency"
                                    />
                                  </td>
                                  <td align="right">
                                    <input
                                      disabled
                                      type="text"
                                      class="form-control f12"
                                      placeholder=""
                                      :value="item.totalPrice | fomatCurrency"
                                    />
                                  </td>
                                  <td align="right" width="50px">
                                    <a
                                      v-if="
                                        dataEdit.isCreatedWithContract &&
                                        dataEdit.state === 'SIGNED_WAITING_APPROVED'
                                      "
                                      @click="removeDevice(index)"
                                      href="#"
                                      class="text-danger"
                                      ><i class="bx bx-trash bx-sm"></i
                                    ></a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
                <div class="modal-footer">
                  <button type="button" @click="closeEditPhuLuc()" class="btn btn-light">
                    Đóng
                  </button>
                  <button @click="submitEdit()" type="button" class="btn btn-primary">
                    Cập nhật
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalErr">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalErr = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalErr = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalSuccess">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    @click="showModalSuccess = false"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/noti-success2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messSuccess }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    data-dismiss="modal"
                    @click="closeNotiSuccess()"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="modalConfirmRemove">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="modalConfirmRemove = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">Bạn có chắc muốn xoá thiết bị này không</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="submitRemove()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="modalConfirmRemove = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'

  export default {
    props: [
      'showModalEditDevice',
      'datadepositType',
      'dataConfigTypeContract',
      'devices',
      'dataEdit',
      'dataContract',
    ],

    data() {
      return {
        dataEditDevice: [],
        showModalErr: false,
        messErr: null,
        showModalSuccess: false,
        messSuccess: null,
        modalConfirmRemove: false,
        indexRemove: '',
      }
    },

    created() {},

    watch: {
      dataEdit(value) {
        this.dataEditDevice = JSON.parse(JSON.stringify(value.appendixDevice.deviceInfos))
      },
      showModalSuccess(value) {
        if (value === false) {
        }
      },
    },

    methods: {
      async closeEditPhuLuc() {
        this.$emit('close')
        this.dataEdit = []
      },

      async closeNotiSuccess() {
        this.$emit('closeSuccess')
        this.$emit('refeshData')
        this.showModalSuccess = false
        this.messSuccess = ''
      },

      async submitEdit() {
        try {
          const validate = await this.$refs.contractAdd.validate()
          if (!validate) {
            return
          }

          this.dataEditDevice.map(e => {
            if (!e.serialNumber && e.serialNumber === '') {
              this.showModalErr = true
              this.messErr = 'Mã serial của thiết bị không được để trống'
            }
          })

          const body = {
            appendixDevice: {
              code: this.dataEdit.code,
              deviceInfos: this.dataEditDevice,
              isDefaultFee: true,
            },
            contractId: this.dataContract.id,
            appendixId: this.dataEdit.appendixId,
            typeAppendix: 'DEVICE',
          }
          const respon = await ContractService.editAppendixPaperContract(body)

          if (respon.code === 1000) {
            this.messSuccess = 'Cập nhập thành công !'
            this.showModalSuccess = true
            return
          }
          this.messErr = 'Cập nhập thất bại !'
          this.showModalErr = respon.message
        } catch (error) {
          console.log(error)
        }
      },

      removeDevice(index) {
        if (this.dataEditDevice.length <= 1) {
          this.showModalErr = true
          this.messErr = 'Mặc định tối thiểu phải có 1 thiết bị'
          return
        }
        if (this.dataEditDevice.length > 1) {
          this.modalConfirmRemove = true
          this.indexRemove = index
          return
        }
        this.dataEditDevice.splice(index, 1)
      },

      submitRemove() {
        this.dataEditDevice.splice(this.indexRemove, 1)
        this.modalConfirmRemove = false
      },
    },
  }
</script>

<style scoped></style>
